var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9123 12.3271H24.5644C23.7463 12.3271 23.083 12.9904 23.083 13.8086C23.083 14.6267 23.7463 15.29 24.5644 15.29H31.9123C32.7305 15.29 33.3937 14.6267 33.3937 13.8086C33.3937 12.9904 32.7305 12.3271 31.9123 12.3271Z",
    fill: "#412A7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9119 20.2676H20.8901C20.0719 20.2676 19.4087 20.9308 19.4087 21.749C19.4087 22.5672 20.0719 23.2304 20.8901 23.2304H31.9119C32.7301 23.2304 33.3933 22.5672 33.3933 21.749C33.3933 20.9308 32.7301 20.2676 31.9119 20.2676Z",
    fill: "#412A7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9118 4.38672H17.4531C16.6349 4.38672 15.9717 5.04997 15.9717 5.86814C15.9717 6.68631 16.6349 7.34957 17.4531 7.34957H31.9118C32.73 7.34957 33.3932 6.68631 33.3932 5.86814C33.3932 5.04997 32.73 4.38672 31.9118 4.38672Z",
    fill: "#412A7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29289 23.7071C7.68342 24.0976 8.31658 24.0976 8.70711 23.7071L15.0711 17.3431C15.4616 16.9526 15.4616 16.3195 15.0711 15.9289C14.6805 15.5384 14.0474 15.5384 13.6569 15.9289L8 21.5858L2.34315 15.9289C1.95262 15.5384 1.31946 15.5384 0.928933 15.9289C0.538409 16.3195 0.538409 16.9526 0.928933 17.3431L7.29289 23.7071ZM7 4.37114e-08L7 23L9 23L9 -4.37114e-08L7 4.37114e-08Z",
    fill: "#412A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescendingIcon);
export default __webpack_public_path__ + "static/media/descendingIcon.66e44fcd796fccac2c3d9bdfea936912.svg";
export { ForwardRef as ReactComponent };